import {useQuery, type UseQueryResult} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyQueries} from '../../api'
import type {UserSuggestionDto} from '../../types'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

// Must match the backend minimum (RiskImprovementActionService.MinNamePatternLength).
export const MIN_USER_SEARCH_LENGTH = 2

export const useUserSuggestions = (
  upmId: string,
  namePattern: string
): UseQueryResult<UserSuggestionDto[], AxiosError> => {
  const pattern = namePattern.trim()

  return useQuery<UserSuggestionDto[], AxiosError>({
    queryKey: riskSurveyQueryKeys.users.suggestions(upmId, pattern),
    queryFn: ({signal}) => riskSurveyQueries.getUserSuggestions(upmId, pattern, signal),
    enabled: !!upmId && pattern.length >= MIN_USER_SEARCH_LENGTH,
    staleTime: 30_000,
    refetchOnWindowFocus: false
  })
}
